import { ChangeEvent, Ref } from "react";
import { IconInput } from "components/input/IconInput";

const DATE_INPUT_MAX_LENGTH = 10; // "DD.MM.YYYY"

interface DateInputProps {
  value: string;
  onChange: (rawValue: string) => void;
  "aria-label": string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
  className?: string;
  onFocus?: () => void;
  onMouseDown?: () => void;
  inputRef?: Ref<HTMLInputElement>;
  inputClassName?: string;
}

export const DateInput = ({
  value,
  onChange,
  "aria-label": ariaLabel,
  "aria-describedby": ariaDescribedBy,
  "aria-invalid": ariaInvalid,
  className,
  onFocus,
  onMouseDown,
  inputRef,
  inputClassName,
}: DateInputProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.slice(0, DATE_INPUT_MAX_LENGTH);
    onChange(rawValue);
  };

  return (
    <IconInput
      ref={inputRef}
      iconName="calendar-days"
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      placeholder="DD.MM.YYYY"
      className={className}
      inputClassName={inputClassName}
      value={value}
      onFocus={onFocus}
      onMouseDown={onMouseDown}
      maxLength={DATE_INPUT_MAX_LENGTH}
      onKeyDownCapture={(e) => {
        // Radix DropdownMenu uses ArrowLeft/ArrowRight for submenu navigation.
        // Prevent bubbling so caret navigation doesn't close the submenu.
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
          e.stopPropagation();
        }
      }}
      onChange={handleChange}
    />
  );
};
